export default {
  // folders: [],
  // documentUserStates: [],
  // documentUserStatesByDocId: {},
  // simpleFolderTree: {},
  // documents: [],
  // foldersById: {},
  // labels: [],
  // labelsMapping: [],
  // tags: [],
  // tagsMapping: [],
};
